/**
* Created For: 省市区三级地区picker选择组件
* this.$emit("areaChange",this.areaCode)  // 传递已选地区数据
* Author: chenLiYan.
* Date: 2018/11/30 0030 16:41.
*/
<template>
  <div class="area-box" @click="pickerHandle()">
    <!--<span class="sprite position icon-position"></span>-->
    <label class="area-li"> {{ areaName.provinceName || '选择省' }} {{ areaName.cityName || '选择市' }} {{ areaName.districtName || '区/县' }}<span class="sprite icon-triangle-left-bottom"></span></label>
  </div>
</template>

<script>
import { getAreaTree } from '@/api/auth'
import { get } from 'lodash'
export default {
  name: 'AreaPicker',
  components: {},
  props: {
    // 默认地址名称，比如定位成功后需显示当前地址信息
    defaultAreaName: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      // 已选地区名称
      areaName: {
        provinceName: '',
        cityName: '',
        districtName: ''
      },
      areaJson: [], // 可选地区数据
      // 已选地区code
      areaCode: {},
      areaPicker: null // 地区选择器
    }
  },
  computed: {},
  watch: {
    defaultAreaName (val) {
      this.areaName = Object.assign({}, val)
    }
  },
  beforeMount () {
    // 初始省市区信息
    this.init()
  },
  methods: {
    // 初始省市区数据
    init () {
      // 查询当前登录用户的可用地区列表
      getAreaTree().then(response => {
        if (response.code === 1) {
          const res = { code: 1, data: [] }
          this.areaJson = response.data
          console.log(res.data)
          if (res.code === 1) {
            console.log('区域数据', this.areaJson)
            this.areaPicker = this.$createCascadePicker({
              data: this.areaJson,
              alias: { value: 'code', text: 'name' },
              onSelect: (selectedVal, selectedIndex, selectedText) => {
                const path = selectedIndex[0] + '.children.' + selectedIndex[1] + '.children.' + selectedIndex[2]
                const centerLatitude = get(this.areaJson, path + '.latitude')
                const centerLongitude = get(this.areaJson, path + '.longitude')
                this.areaName = {
                  provinceName: selectedText[0],
                  cityName: selectedText[1],
                  districtName: selectedText[2]
                }
                this.areaCode = {
                  provinceCode: selectedVal[0],
                  cityCode: selectedVal[1],
                  districtCode: selectedVal[2]
                }

                // 传递已选地区数据
                this.$emit('areaChange', { ...this.areaCode, centerLatitude, centerLongitude })
              },
              onCancel: () => {
                this.$emit('cancel')
              }
            })
          }
        }
      }).catch(() => {
      })
    },
    // 选择点击事件
    pickerHandle () {
      if (this.areaJson.length > 0) {
        this.areaPicker && this.areaPicker.show()
        this.$emit('pickerClick')
      }
    },
    // 设置默认显示名称
    setDefaultName (areaNameObj) {
      this.areaName = areaNameObj || {}
    },
    // 设置默认地区值
    setDefaultArea (areaCodeObj) {
      this.areaCode = areaCodeObj || {}
      const defaultIndex = this.getSelectorIndex([this.areaCode.provinceCode, this.areaCode.cityCode, this.areaCode.districtCode])
      this.areaPicker && this.areaPicker.setData(this.areaJson, defaultIndex)
    },
    // 获取初始值在列表中的序号,无则返回0
    getIndexInList (val, list = [], key) {
      key = key || 'code'
      let index = -1
      for (let i = 0; i < list.length; i++) {
        if (list[i][key] === val) {
          index = i
          break
        }
      }
      return index
    },
    // 获取初始的省市区文字及索引
    getSelectorIndex (defaultAreaArr, indexArr) {
      indexArr = indexArr || [0, 0, 0]
      const len = 0
      // 获取具体的下标
      const getIndex = function (len, field) {
        for (let k = 0; k < field.length; k++) {
          if (defaultAreaArr[len] === field[k].code) {
            indexArr[len] = k
            len++
            if (len >= defaultAreaArr.length) {
              break
            }
            getIndex(len, field[k].children)
          }
        }
      }
      if (len < defaultAreaArr.length) {
        getIndex(len, this.areaJson)
      }
      return indexArr
    }
  }
}
</script>

<style lang="stylus" scoped>
    @import "../stylus/base/base.styl"
    .area-box{
        width 600px
        padding-left 32px
        font-size 0
        position relative
        .position{
            position absolute
            left 29px
            top 50%
            transform translate(0,-50%)
        }
        .area-li{
            max-width 600px
            line-height 36px
            font-size $font-XXL
            padding-right 28px
            $mixin-ellipsis()
            position relative
            .sprite{
                position absolute
                bottom 5px
                right -3px
            }
        }
    }
</style>
